<template>
  <div>
    <a-spin :spinning="spinning">
    <div class="seachBox flex">
      <div class="seachList"><span class="name">客户名称：</span>
        <a-input placeholder="" @keydown="searchKey" class="seachs" v-model="seach.company"/>
      </div>
      <div class="seachList"><span class="name">网 址：</span>
        <a-input placeholder=""  @keydown="searchKey" class="seachs" v-model="seach.domain"/>
      </div>
      <div class="seachList"><span class="name">邮 箱：</span>
        <a-input placeholder=""  @keydown="searchKey" class="seachs" v-model="seach.email"/>
      </div>
      <div class="seachList"><span class="name">手机号：</span>
        <a-input placeholder=""  @keydown="searchKey" class="seachs" v-model="seach.mobile"/>
      </div>
      <div class="seachList"><span class="name">版 本：</span>
        <a-select v-model="seach.a_version_id" class="seachs" allowClear   @keydown.enter.native="searchKey">
          <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.versionList">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div class="seachList"><span class="name">行 业：</span>
<!--        <a-select v-model="seach.a_customer_industry_id" class="seachs" allowClear-->
<!--                  @keydown.enter.native="searchKey">-->
<!--          <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.industryList">-->
<!--            {{item.name}}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
        <a-cascader class="seachs"
                    :load-data="loadData"
                    @keydown.enter.native="searchKey"
                    :fieldNames="fieldNames"
                    v-model="seach.a_customer_industry_id"
                    :options="seachList.industryList"
                    change-on-select
                    placeholder=""
        />
      </div>
      <div class="seachList"><span class="name">模板编号：</span>
        <a-input placeholder="" class="seachs" v-model="seach.code"  @keydown="searchKey" />
      </div>

      <div class="seachList"><span class="name">AIChat：</span>
        <a-select v-model="seach.is_open_chatgpt" class="seachs" allowClear  @keydown.enter.native="searchKey">
          <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.isOpenChatgptList">
            {{item.name}}
          </a-select-option>
        </a-select></div>
<!--      <div class="seachList"><span class="name">开通状态：</span>-->
<!--        <a-select v-model="seach.is_open_customers" class="seachs" allowClear  @keydown.enter.native="searchKey">-->
<!--          <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.isOpenCustomersList">-->
<!--            {{item.name}}-->
<!--          </a-select-option>-->
<!--        </a-select>-->
<!--      </div>-->

      <div class="seachList"><span class="name">状态：</span>
        <a-select v-model="seach.state_type" class="seachs" allowClear  @keydown.enter.native="searchKey">
          <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.stateTypeList">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div class="seachList"><span class="name">客户来源：</span>
        <a-select v-model="seach.customer_source" class="seachs" allowClear  @keydown.enter.native="searchKey">
          <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.customerSourceList">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>

      <div class="seachList"><span class="name">网站类型：</span>
        <a-select v-model="seach.site_type" class="seachs" allowClear  @keydown.enter.native="searchKey">
          <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.siteTypeList">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>

      <div class="seachList"><span class="name">客户类型：</span>
        <a-select v-model="seach.type" class="seachs" allowClear  @keydown.enter.native="searchKey">
          <a-select-option :value="item.value" :key="index" v-for="(item,index) in seachList.typeList">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div class="seachList"><span class="name">代理商：</span>
        <a-select v-model="seach.a_agent_id	" class="seachs" allowClear  @keydown.enter.native="searchKey">
          <a-select-option :value="item.id" :key="index" v-for="(item,index) in seachList.agentList">
            {{item.name}}
          </a-select-option>
        </a-select>
      </div>
      <div class="seachList"><span class="name">上线日期：</span>
        <a-range-picker class="seachs" v-model="seach.online_time" @keydown.enter.native="searchKey" :allowClear="false" :showTime="false"  format="YYYY-MM-DD"/>
      </div>
      <div class="seachList"><span class="name">到期日期：</span>
        <a-range-picker class="seachs" v-model="seach.expire_time" @keydown.enter.native="searchKey" :allowClear="false" :showTime="false"  format="YYYY-MM-DD"/>
      </div>
<!--      <div class="seachList no"></div>-->
<!--      <div class="seachList no"></div>-->
<!--      <div class="seachList no"></div>-->

      <!--            <div class="seachList no"></div>-->
      <div class="seachList" style="text-align: center;width: 100%;margin-top: 15px;">
        <a-button type="primary" class="seachBtn" @click="getList(1)" style="margin-right: 10px"> 查询</a-button>
        <a-button class="seachBtn" @click="resetSeach()">重置</a-button>
      </div>
    </div>
    <a-button class="top_btn" type="primary" @click="()=>{visibleForm = true; titleForm='添加客户' ;this.editId=''; }" v-has="'btn_add'" >
      添加客户
    </a-button>
    <a-button class="top_btn" type="primary" @click="WriteLetters" :disabled="!hasSelected" >
      发邮件
    </a-button>
    <a-button class="top_btn" type=" " @click=" exper">
      导出
    </a-button>
    <a-button class="top_btn" type="primary" @click="AIChat('open')" :disabled="!hasSelected">
      开启AIChat
    </a-button>
    <a-button class="top_btn" type="primary" @click="AIChat('close')" :disabled="!hasSelected">
      关闭AIChat
    </a-button>
    <a-popconfirm
        title="确定要重载nginx配置么?"
        ok-text="确定"
        cancel-text="取消"
        @confirm="loadingNginxConfig()"
        @cancel="()=>{}"
    >
      <a-button class="top_btn" type="primary">
        重载配置
      </a-button>
    </a-popconfirm>
    <a-button class="top_btn" :class="{gray: !hasSelected || webmasterToolAccBtnGray}" type="primary" @click="openWebmasterToolAccounts">
      关联站长工具账号
    </a-button>
    <a-button class="top_btn" :class="{gray: !hasSelected || sitmpaBtnGray || sitmpaBtnGraySSL}" :disabled="sitmapBtnDis" type="primary" @click="createSitemap">
      {{ !sitmapBtnDis ? '生成Sitemap' : '生成中' }}
    </a-button>
      <!--      :disabled="!hasSelected"-->
    <a-table :columns="columns" :data-source="data" :loading="loading" :pagination="pagination" rowKey="id"
             :row-selection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"  :scroll="{ x: 1300 }">
      <div slot="company" slot-scope="text, record">
        <!--              width:15px-->
        <span style="display: inline-block ;"> <a-tooltip placement="left" :title="record.erp_remark" :get-popup-container="getPopupContainer" v-if='record.erp_remark'> <a-icon type="container"  style="cursor: pointer"/> </a-tooltip>
     </span>

        <p  style="color: #f00" v-if="record.is_red_robots==1">{{text}} </p>
        <p v-else>{{text}} </p>
      </div>
      <span slot="a_customer_industry_name" slot-scope="text, record" :title="text" style="word-break:break-all;overflow: hidden;display: -webkit-box;-webkit-line-clamp: 2;-webkit-box-orient: vertical;" >{{text}}</span>

      <span slot="chatgpt" slot-scope="text, record">
         <a-switch @click="onChange(record)" :checked="text==1?true:false" />
      </span>
      <span slot="action" slot-scope="text, record" >
        <i v-if="$_hasAll(['btn_edit','btn_role'])" style="color:#838383">暂无操作权限</i>
        <a @click="(record) => { visibleJurisdiction = true; titleForm='权限查看';jurisdictionId=text.id ;  }" v-has="'btn_role'">权限查看 <a-divider  type="vertical"/></a>
        <template v-if="text.is_open_customers==1" >
           <a @click="(record)=>{visibleForm = true; titleForm='修改客户'; editId=text.id ; }" v-has="'btn_edit'" >编辑</a><a-divider  type="vertical"/>
           <a @click="editNum(text.id)">修改字符数</a>
        </template>
        <a v-else @click="(record)=>{openCustomers = true; titleForm='开通客户';openCustomersId=text.id ; }" v-has="'btn_edit'">开通</a>
        <a href="" v-if="text.is_service_order==1"><a-divider  type="vertical"/><router-link :to="{ path:'/CustomerManagement/Finance', query:{id:record.id,name:record.company}}">财务</router-link></a>
    <br/>
       <a v-if="record.bt_online_status==2"  @click="baota(1,record.id)"> 宝塔正式上线 </a>
        <a v-else style="color: #666"> 宝塔已上线 </a>

        <a v-if="record.bt_ssl_status==2"  @click="baota(2,record.id)"><a-divider  type="vertical"/>申请宝塔ssl证书</a>
        <a  v-else style="color: #666" ><a-divider  type="vertical"/>已设置宝塔证书</a>
        <a v-if="record.bt_ssl_status==1"  @click="Sitemap(record.id)"><a-divider  type="vertical"/>生成Sitemap</a>
        <a v-if="record.google_search_console_email" @click="checkWebsite([record.id])"><a-divider  type="vertical"/>网站检测</a>


        <a v-if="record.is_online==1 " @click="checkSitemap(record.id)"><a-divider  type="vertical"/>Yandex开通</a>
        <a v-if="record.is_online==1 " @click="checkRoots(record.id)"><a-divider  type="vertical"/>robots开通</a>
        <a :href="record.ksh_url" target="_blank"><a-divider  type="vertical"/>新可视化编辑</a>
      </span>
    </a-table>
    <CustomerForm :visibleForm="visibleForm" :titleForm="titleForm" :editId="editId"
                  @changVisible=" () => { this.visibleForm = false;this.editId=''; this.getList(this.page)}  "/>
    <JurisdictionForm :visibleJurisdiction="visibleJurisdiction" :title="titleForm" :jurisdictionId="jurisdictionId"
                      @changVisible=" () => { this.visibleJurisdiction = false;this.jurisdictionId='';  this.getList(this.page)}  "
    />
    <OpenCustomers :visibleForm="openCustomers" :titleForm="titleForm" :openCustomersId="openCustomersId"
                   @changVisible=" () => { this.openCustomers = false;this.openCustomersId=''; this.getList(this.page)}  "/>
      <a-modal
          v-model="translateVisible"
          :title="`修改翻译  当前剩余${translateNum}`"
          centered
          width="60%"
          :footer="null"
          @ok="onClose"
          @cancel="onClose"
      >
        <a-form-model ref="ruleForm" :model="form" :rules="rules" v-bind="layout" :colon="false">
          <a-form-model-item
              ref="num"
              label="添加"
              prop="num"
              :help="formErr.num"
              :validateStatus='!formErr.num||formErr.num==""?"":"error"'
          >
            <a-input  :maxLength=6   :precision="0"
                      oninput="value=value.replace(/[^\d,-]/g,'')"
                            v-model="form.num"
                            @change="(e) => { formErr.num=''}"
                             @blur="(e) => {lengthInput()  }"   style="width: 100px"/>
            <span style="position: absolute;right:-140px">万 （减少可填负数）</span>
          </a-form-model-item>
          <a-form-model-item
              ref="remark"
              label="备注"
              prop="remark"
              :help="formErr.remark"
              :validateStatus='!formErr.remark||formErr.remark==""?"":"error"'
          >
            <a-textarea :maxLength=200 :rows="4" v-model="form.remark"
                        @change="(e) => { formErr.remark=''}"
                        @blur="(e) => {  form.remark = e.target.value.trim() }"/>
          </a-form-model-item>
          <a-form-model-item   label="  "  >
            <a-button type="primary" @click="onSubmit" :style="{ marginRight: '8px' }">
              保存
            </a-button>
            <a-button   @click="onClose">
              关闭
            </a-button>
          </a-form-model-item>

<!--         -->
          <p style="border-top: 1px dashed #c1c1c1;padding-top: 20px;font-size: 16px">修改记录</p>
          <a-table :columns="translateColumns" :data-source="translateData" :pagination="false" rowKey="id" :scroll="{y: 20 }">

          </a-table>
        </a-form-model>

      </a-modal>

    </a-spin>
    <GoogleAccount ref="accountRef" :data="googleAccount" @success="bindAccounsucc"></GoogleAccount>
    <!-- Sitemap确认弹窗 -->
    <ConfimModal ref="confimRef" @confirm="createSitemapStart"></ConfimModal>
    <!-- Sitemap生成弹窗 -->
    <SitmapCreateModal ref="sitemapCreateRef" @createSitemapEnds="createSitemapEnds"></SitmapCreateModal>
    <!-- 账号网站验证弹窗 -->
    <CheckWebsiteModal ref="checkWebsiteRef" @detail="checkWebsiteDetail"></CheckWebsiteModal>
    <!-- 账号网站验证弹窗-详情 -->
    <CheckWebsiteDetailModal ref="checkWebsiteDetailRef"></CheckWebsiteDetailModal>
  </div>
</template>
<script>

import API from "./api";
import moment from 'moment';
import CustomerForm from "./components/customerForm"
import JurisdictionForm from "./components/jurisdictionForm"
import OpenCustomers from "./components/openCustomers"
import GoogleAccount from "./components/googleAccount"
import ConfimModal from "./components/confimModal"
import SitmapCreateModal from "./components/sitmapCreateModal"
import CheckWebsiteModal from "./components/checkWebsiteModal"
import CheckWebsiteDetailModal from "./components/checkWebsiteDetailModal"
import {changStatus, submitForm, validator} from "@/utils/utils"

const translateColumns= [
  {
    title: "增加数量（万）",
    dataIndex: "change_num",
    ellipsis: true,
    width: "150px",
    scopedSlots: {customRender: "change_num"},
    key: "change_num"
  },
  {
    title: "总量（万）",
    dataIndex: "total_num",
    ellipsis: true,
    width: "120px",
    key: "total_num"
  },
  {
    title: "添加时间",
    dataIndex: "create_time",
    ellipsis: true,
    width: "200px",
    key: "create_time"
  },{
    title: "备注",
    dataIndex: "remark",
    ellipsis: true,
    key: "remark"
  }]
const columns = [
  {
    title: "客户名称",
    dataIndex: "company",
    width: "300px",
    ellipsis: true,
    scopedSlots: {customRender: "company"},
    key: "company"
  },
  {
    title: "合同编号",
    dataIndex: "erp_contract_number",
    width: "200px",
    ellipsis: true,
    scopedSlots: {customRender: "erp_contract_number"},
    key: "erp_contract_number"
  },
  {
    title: "邮箱",
    dataIndex: "email",
    width: "200px",
    ellipsis: true,
    key: "email"
  },
  {
    title: "手机号",
    dataIndex: "mobile",
    width: "200px",
    ellipsis: true,
    key: "mobile"
  },
  {
    title: "网址",
    dataIndex: "domain",
    width: "180px",
    ellipsis: true,
    key: "domain"
  },
  {
    title: "合同版本",
    dataIndex: "a_version_name",
    ellipsis: true,
    width: "100px",
    key: "a_version_name"
  },
  {
    title: "行业",
    dataIndex: "a_customer_industry_name",

    width: "200px",
    key: "a_customer_industry_name",
    scopedSlots: {customRender: "a_customer_industry_name"}
  },
  {
    title: "语种数量",
    dataIndex: "lang_num",
    ellipsis: true,
    width: "100px",
    key: "lang_num"
  },
  {
    title: "关联账号",
    dataIndex: "google_search_console_email",
    ellipsis: true,
    width: "200px",
    key: "google_search_console_email"
  },
  {
    title: "模板编号",
    dataIndex: "code",
    ellipsis: true,
    width: "150px",
    key: "code"
  },
  {
    title: "上线日期",
    dataIndex: "online_time",
    width: "150px",
    ellipsis: true,
    key: "online_time"
  },
  {
    title: "到期日期",
    dataIndex: "expire_time",
    width: "150px",
    ellipsis: true,
    key: "expire_time"
  },{
    title: "客户类型",
    dataIndex: "type_name",
    width: "150px",
    ellipsis: true,
    key: "type_name"
  },
  {
    title: "AIChat",
    key: "is_open_chatgpt",
    width: "100px",
    dataIndex: "is_open_chatgpt",
  scopedSlots: {customRender: "chatgpt"}
  },
  {
    title: "开通状态",
    dataIndex: "is_open_customers_name",
    ellipsis: true,
    width: "150px",
    key: "is_open_customers_name"
  },
  {
    title: "启用/停用",
    key: "status_name",
    width: "100px",
    dataIndex: "status_name",
    // scopedSlots: {customRender: "status"}
  },
  {
    title: "网站类型",
    dataIndex: "site_type_name",
    ellipsis: true,
    width: "170px",
    key: "site_type_name"
  },
  {
    title: "客户类型",
    dataIndex: "type_name",
    ellipsis: true,
    width: "100px",
    key: "type_name"
  },
  {
    title: "操作",
    key: "action",
    width: "290px",
    fixed: 'right',
    scopedSlots: {customRender: "action"}
  }
];

export default {
  name: "Customer",
  data() {
    return {  fieldNames: {label: 'name', value: 'id', children: 'children'},
      translateData:[],
      form: {
        remark: "",
        num: ""
      },
      formErr: {
        num: "",
        remark: ""
      },
      rules: {
        num: [{required: true, message: "请输入数字", trigger: "blur"}, {
          validator: (rule, value, callback) => {
            validator(rule, value, callback, this.formErr.num)
          }, trigger: "blur"
        },],
      },
      layout: {
        labelCol: {span:2},
        wrapperCol: {span: 14},
      },
      translateNum:"",
      translateVisible:false,
      // visibleType:1,
      spinning: false,
      selectedRowKeys: [],
      resetSeachdata:true,
      page:1,
      seach: {
        site_type:"",
        company: "",
        domain: "",
        mobile:'',
        email:'',
        a_version_id: "",
        a_customer_industry_id: "",
        a_server_year_id: "",
        customer_source:"",
        is_open_customers:"",
        is_open_chatgpt:'',type:'',
        a_agent_id:'',
        state_type:'',
        online_time: [],
        expire_time: [],
      },
      seachList: {
        isOpenChatgptList:[],
        industryList: [],
        versionList: [],
        serverYearList: [],
        siteTypeList:[],
        isOpenCustomersList:[],
        customerSourceList:[],typeList:[],agentList:[],stateTypeList:[]
      },
      pagination: {
        pageNo: 1,
        pageSize: 20, // 默认每页显示数量
        onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
        onChange: this.getList.bind(this), //点击页码事件
        total: 0, //总条数
        current: 0,
        size: "small",
        showTotal: total => `共 ${total} 条`,
        showQuickJumper: true
      },
      data: [],
      columns,
      translateColumns,
      loading: true,
      visibleForm: false,
      openCustomers:false,
      titleForm: "",
      editId: null,
      openCustomersId:null,
      jurisdictionId: null,
      visibleJurisdiction: false,
      googleAccount: [],
      sitmapBtnDis: false,
    }
  },
  created() {
    this.$store.state.adminleftnavnum = "/CustomerManagement/CustomerList"; //设置左侧导航2-2 active
  },
  mounted() {
    if(this.$route.query.aAgentId )this.seach.a_agent_id=this.$route.query.aAgentId*1
    this.getList()
    this.getIndustry()
    this.getGoogleAccountList()
  },
  computed: {
    hasSelected() { 
      return this.selectedRowKeys.length > 0;
    },
    webmasterToolAccBtnGray() {
      // 关联站长工具账号按钮状态
      let THAT=this
      let flag = false
      THAT.data.map(item=>{
         if(THAT.selectedRowKeys.indexOf(item.id)>-1){
          if(item.google_search_console_email || item.bt_ssl_status != 1){
            flag = true
          }
         }
      })
      return flag
    },
    sitmpaBtnGray() {
      // 生成Sitemap按钮状态
      let THAT=this
      let flag = false
      THAT.data.map(item=>{
         if(THAT.selectedRowKeys.indexOf(item.id)>-1){
          if(!item.google_search_console_email){
            flag = true
          }
         }
      })
      return flag
    },
    sitmpaBtnGraySSL() {
      // 生成Sitemap按钮状态
      let THAT=this
      let flag = false
      THAT.data.map(item=>{
         if(THAT.selectedRowKeys.indexOf(item.id)>-1){
          if(item.bt_ssl_status != 1){
            flag = true
          }
         }
      })
      return flag
    },
    sitemapBtnDis() {
      // 关联站长工具账号按钮状态
      let THAT=this
      let flag = false
      THAT.data.map(item=>{
         if(THAT.selectedRowKeys.indexOf(item.id)>-1){
          if(item.google_search_console_email){
            flag = true
          }
         }
      })
      return flag
    },
  },
  components: {CustomerForm, JurisdictionForm,OpenCustomers, GoogleAccount, ConfimModal, SitmapCreateModal, CheckWebsiteModal, CheckWebsiteDetailModal},
  methods: {
    loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];
      targetOption.loading = true;
      let THAT=this
      API.customer.GET_INDUSTRY_LIST({parent_id: selectedOptions[selectedOptions.length-1].id}).then(res => {
        targetOption.loading = false;
        targetOption.children = res.data.data
        THAT.seachList.industryList=[...THAT.seachList.industryList]
      })
    },
    lengthInput(e){
      if(this.form.num.indexOf("-")>-1){
        if(this.form.num.indexOf("-")==0){
          this.form.num=`-${this.form.num.replace(/[^\d]/g, "")}`
        }else{
          this.form.num=`${this.form.num.replace(/[^\d]/g, "")}`
        }
      }
      this.form.num= this.form.num.trim()
    },
    onClose(){
      this.translateVisible = false
      this.translateNum=""
      this.translateData=[]
      this.form={ remark: "", num: "" }
      this.formErr={ num: "", remark: "" }
      this.$refs.ruleForm.resetFields();
    },
    onSubmit() {
      let _this = this;
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          let url
            submitForm(API.customer.CHANGE_TRANSLATION_NUM_POST, _this.form).then(res => {
            if (res == true) {
              // this.onClose()
              this.editNum(this.form.id)
              this.form={ remark: "", num: "" ,id:this.form.id}
              this.formErr={ num: "", remark: "" }
              this.$refs.ruleForm.resetFields();
            } else {
              res.map((item, index) => {
                this.formErr[item.field] = item.msg
              })
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    editNum(id){
      this.form.id=id
      API.customer.CHANGE_TRANSLATION_NUM({id}).then(res => {
        this.translateVisible = true
        this.translateNum=res.data.data.info.translation_surplus
        this.translateData=res.data.data.recordList
        console.log(this.translateData)
      })
    },
    Sitemap(id){
      let THAT=this
      this.$confirm({
        title: '提示',
        content:`是否确定生成Sitemap`,
        okText: '确定',
        cancelText: '取消',
        onOk() {
          const hide = THAT.$message.loading('正在提交', 0);
          API.customer.SITEMAP({id}).then(res => {
            THAT.spinning=false
            if(res.data.code==200){
              setTimeout(hide, 0);
              THAT.$message.success(res.data.msg);
              THAT.getList(1)
            }else{
              setTimeout(hide, 0);
            }

          })
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    baota(type,id){
      // if(type==1)
      let THAT=this
      this.$confirm({
        title: '提示',
        content:`${type==1?'是否确定上线':'是否确定申请证书'}`,
        okText: '确定',
        cancelText: '取消',
        onOk() {
          THAT.spinning=true
          let removeKey = 'removetable';
          const hide = THAT.$message.loading('正在提交', 0);
          type==1?API.customer.BAOTA({id}).then(res => {
            THAT.spinning=false
            if(res.data.code==200){
              setTimeout(hide, 0);
              THAT.$message.success(res.data.msg);
              THAT.getList(1)
            }else{
              setTimeout(hide, 0);
            }

           }):API.customer.BAOTASSL({id}).then(res => { THAT.spinning=false
            if(res.data.code==200){
              setTimeout(hide, 0);
              THAT.$message.success(res.data.msg);
              THAT.getList(1)
            }else{
              setTimeout(hide, 0);
            }
          })
          console.log('OK');
        },
        onCancel() {
          console.log('Cancel');
        },
      });
    },
    searchKey(){
      if(event.keyCode == 13){
        this.getList(1)
      }
    },
    exper(id) {
      let seachData=JSON.parse(JSON.stringify(this.seach))
      if (seachData.expire_time.length > 0&&this.resetSeachdata==true) {
        seachData.expire_time[0] = moment(this.seach.expire_time[0]).format('YYYY-MM-DD')
        seachData.expire_time[1] = moment(this.seach.expire_time[1]).format('YYYY-MM-DD')
      }else{
        seachData.expire_time=[]
      }
      if (seachData.online_time.length > 0&&this.resetSeachdata==true) {
        seachData.online_time[0] = moment(this.seach.online_time[0]).format('YYYY-MM-DD')
        seachData.online_time[1] = moment(this.seach.online_time[1]).format('YYYY-MM-DD')
      }else{
        seachData.online_time=[]
      }
      API.customer.EXPORT({...seachData,ids:this.selectedRowKeys}).then(res => {
        window.open( `${this.$store.state.urlExper}${res.data.data.substr(1)}`  )
        // this.getList()
        // this.selectedRowKeys = []
      })
    },
    WriteLetters(){
      let _that=this
      this.$router.push({path: '/CustomerManagement/WriteLetters', query: {id:_that.selectedRowKeys.toString()}})
    },
    onSelectChange(selectedRowKeys) {
      this.selectedRowKeys = selectedRowKeys;
    },
    onChange(row) {
      let Json = {id: row.id, is_open_chatgpt: row.is_open_chatgpt == 2 ? 1 : 2}
      changStatus(API.customer.CHANG_CHAT_STATUS,  Json ).then(res => {
        if (res == true) {
          this.getList()
        }
      })
    },
    resetSeach() {
      // return
      this.resetSeachdata=false
      // alert(this.seach.online_time.length)
      this.seach = {
        company: "",
        domain: "",
        a_version_id: "",
        a_customer_industry_id: "",
        a_server_year_id: "",
        site_type:"",
        type:'',a_agent_id:'',state_type:'',
        online_time:this.seach.online_time.length>0?[moment(new Date(), 'YYYY-MM-DD'), moment(new Date(), 'YYYY-MM-DD')]:[],
        expire_time:this.seach.expire_time.length>0?[moment(new Date(), 'YYYY-MM-DD'), moment(new Date(), 'YYYY-MM-DD')]:[],
      }
      this.resetSeachdata=false
      this.getList(1)
    },
    getList(page) {
      this.loading = true
      this.selectedRowKeys=[]
      this.page=page
      let seachData=JSON.parse(JSON.stringify(this.seach))
      if (seachData.expire_time.length > 0&&this.resetSeachdata==true) {
        seachData.expire_time[0] = moment(this.seach.expire_time[0]).format('YYYY-MM-DD')
        seachData.expire_time[1] = moment(this.seach.expire_time[1]).format('YYYY-MM-DD')
      }else{
        seachData.expire_time=[]
      }
      if (seachData.online_time.length > 0&&this.resetSeachdata==true) {
        seachData.online_time[0] = moment(this.seach.online_time[0]).format('YYYY-MM-DD')
        seachData.online_time[1] = moment(this.seach.online_time[1]).format('YYYY-MM-DD')
      }else{
        seachData.online_time=[]
      }
      API.customer.GET_LIST({page: page || 1, ...seachData}).then(res => {
        this.data = res.data.data.info.data

        this.seachList.versionList = res.data.data.versionList
        this.seachList.serverYearList = res.data.data.serverYearList
        this.seachList.siteTypeList = res.data.data.siteTypeList
        this.seachList.customerSourceList = res.data.data.customerSourceList
        this.seachList.isOpenCustomersList = res.data.data.isOpenCustomersList
        this.seachList.isOpenChatgptList = res.data.data.isOpenChatgpt
        this.seachList.typeList = res.data.data.typeList
        this.seachList.agentList = res.data.data.agentList
        this.seachList.stateTypeList = res.data.data.stateTypeList

        // if(res.data.data.info.data.length>0){
        this.pagination.total = res.data.data.info.total
        this.pagination.pageSize = res.data.data.info.per_page
        this.pagination.current = res.data.data.info.current_page
        // }
        if(!this.resetSeachdata==true){
          this.seach.online_time=[]
          this.seach.expire_time=[]
        }
        this.resetSeachdata=true
        this.loading = false
      })
    },
    getIndustry(){
      API.customer.GET_INDUSTRY_LIST({parent_id:0}).then(res => {
        this.seachList.industryList = res.data.data
      })
    },
    AIChat(type){
      let url
      type=='open'?url=API.customer.OPEN_CHAT_GPT_STATUS:url=API.customer.CLOSE_CHAT_GPT_STATUS
      url({ids:this.selectedRowKeys}).then(res => {
        if(res.data.code==200){
          this.$message.success(res.data.msg);
          this.getList(1)
        }
      })
    },
    loadingNginxConfig(){
      let THAT=this
      THAT.spinning=true
      let hide = THAT.$message.loading('正在提交', 0);
      API.customer.LOADING_NGINX_CONFIG().then(res => {
        THAT.spinning=false
        if(res.data.code==200){
          setTimeout(hide, 0);
          THAT.$message.success(res.data.msg);
        }else{
          setTimeout(hide, 0);
        }
      })
    },
    // 关联站长工具账号下拉数据
    getGoogleAccountList() {
      let THAT=this
      API.customer.GET_GOOGLE_SEARCH_CONSOLE().then(res => {
        if (res.data.code == 200) {
          THAT.googleAccount = res.data.data; 
        }
      })
    },
    // 开通Sitemap
    checkSitemap(id) {
      let THAT=this
      API.customer.OPEN_SITEMAP({id}).then(res => {
        if (res.data.code == 200) {
          THAT.$message.success(res.data.msg);
          // THAT.googleAccount = res.data.data;
        }
      })
    },
    // 开通Roots
    checkRoots(id) {
      let THAT=this
      API.customer.OPEN_ROBOTS({id}).then(res => {
        if (res.data.code == 200) {
          THAT.$message.success(res.data.msg);
          // THAT.googleAccount = res.data.data;
        }
      })
    },
    // 关联站长工具账号
    openWebmasterToolAccounts(){
      let THAT=this
      if(THAT.selectedRowKeys.length==0){
        THAT.$message.destroy()
        THAT.$message.warning('请先选择客户数据')
        return
      }
      if(THAT.webmasterToolAccBtnGray){
        THAT.$message.destroy()
        THAT.$message.warning('请检测客户数据！')
        return
      }
      THAT.$refs.accountRef.open(THAT.selectedRowKeys) 
    },
    bindAccounsucc(ids) {
      let THAT=this
      THAT.getList(THAT.page)
      THAT.checkWebsite(ids)
    },
    // 生成Sitemap
    createSitemap(){
      let THAT=this
      if(THAT.selectedRowKeys.length==0){
        THAT.$message.destroy()
        THAT.$message.warning('请先选择客户数据')
        return
      }
      if(THAT.sitmpaBtnGray){
        THAT.$message.destroy()
        THAT.$message.warning('请先关联站长工作账号')
        return
      }
      if(THAT.sitmpaBtnGraySSL){
        THAT.$message.destroy()
        THAT.$message.warning('请先申请宝塔证书')
        return
      }
      THAT.$refs.confimRef.open() 
    },
    createSitemapStart() {
      let THAT=this
      let domain = []
      THAT.data.map(item=>{
         if(THAT.selectedRowKeys.indexOf(item.id)>-1){
          item.domain ? domain.push(item.domain) : ''
         }
      })
      THAT.sitmapBtnDis = true
      THAT.$refs.sitemapCreateRef.open(THAT.selectedRowKeys, domain) 
    },
    createSitemapEnds() {
      THAT.sitmapBtnDis = false
    },
    // 网站检测
    checkWebsite(ids){
      let THAT=this
      THAT.$refs.checkWebsiteRef.open(ids) 
    },
    // 详情
    checkWebsiteDetail(data){
      let THAT=this
      THAT.$refs.checkWebsiteDetailRef.open(data) 
    },
  }
}
</script>
<style scoped>
.seachBox .seachBtnBox .seachBtn{margin-top: 0!important;}
.seachBox .seachList .seachs.white >>> .ant-input{color: #fff!important;}
.seachBox .seachList .seachs.white >>> .ant-calendar-range-picker-separator{color: #fff!important;}
.seachBox .seachList .seachs.white >>> .ant-calendar-picker{color: #fff!important;}
.ant-btn.gray { color: rgba(0, 0, 0, 0.25); background-color: #f5f5f5; border-color: #d9d9d9; text-shadow: none; box-shadow: none;}
</style>
